module.exports = __webpack_public_path__ + "static/media/profile-tim-wilkins.198432fd.png";